export default __webpack_public_path__ + "static/media/account-active-tab-icon.73e60ae9.svg";